import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import { AppBar, Toolbar, Badge } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../assets/ls_logo.png';
import NavLink from './NavLink';
import StoreSwitcher from './StoreSwitcher';
import { useEffect, useState } from 'react';
const MR_BASE_API = process.env.REACT_APP_MESSAGE_RUNNER_URL
const STAGE = process.env.REACT_APP_SC_STAGE

const Nav = ({ storeId, isAdmin, isFeaturesAdmin }) => {
  const classes = useStyles();
  const [messageRunnerUrl, setMessageRunnerUrl] = useState(`${MR_BASE_API}/home?currentStoreId=${storeId}`)

  useEffect(() => {
    const url= `${MR_BASE_API}/home?currentStoreId=${storeId}` 
    setMessageRunnerUrl(url)
}, [storeId]);

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar} id="nav-bar" elevation={5}>
        <Toolbar variant="regular" >
          <div className={classes.navContainer}>{<NavLink text="Home" url="/home" isFeaturesAdmin={isFeaturesAdmin} isAdmin={isAdmin} />}</div>
          <div className={classes.headerContainer}>
              <div className={classes.logoContainer}>
                <div>
                  <Badge badgeContent={STAGE.toUpperCase()} color='secondary' className='nav-span-text' invisible={(STAGE === 'prod')}>
                  <img className={classes.logo} src={logo} alt="ls-logo"/>
                  </Badge>
                </div>
                <div className={classes.linkButton} >
                  <button className='button red' id="mrLinkButton">
                    <a href={messageRunnerUrl} className={classes.messageRunnerLink}  referrerPolicy='unsafe-url' target= 'message-runner' >Message Runner</a> 
                  </button>
                </div>
              </div>
            <div className="store-switcher-container" >
              <StoreSwitcher storeId={storeId} isAdmin={isAdmin} />
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}

const useStyles = makeStyles({

  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  menuLink: {
    underline: 'none',
    color: 'black',
    textDecoration: 'none',
  },
  appBar: {
    zIndex: 200,
    backgroundColor: '#fff',
  },
  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '15px',
    paddingTop: '15px'
  },
  label: {
    fontSize: '12px',
    textAlign: 'right',
    marginBottom: '5px',
    paddingRight: '15px',
    marginTop: '-4px',
  },
  linksContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  logo: {
    height: '40px',
    marginTop: '5px',
    display: 'block',
  },
  logoContainer: {
    margin: '0px',
    display: 'flex',
    gap: '2em',
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
  },
  navLink: {
    fontSize: '1em',
    fontWeight: '700',
    textDecoration: 'none',
    padding: '5px 20px 5px 20px',
    marginRight: '15px',
    width: '100%',
    color: '#FFF',
  },
  root: {
    display: 'flex',
  },
  navContainer: {
    display: 'flex',
    width: '9%',
  },
  messageRunnerLink: {
    textTransform: "capitalize !important",
    color: '#FFF !important',
    height: '40px',
  },
  linkButton: {
    width: '33%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '2px'
  },
  alignItems: {
    display: 'flex',
    alignItems: 'center',
  }
});

Nav.propTypes = {
  history: ReactRouterPropTypes.history,
};

export default withRouter(Nav)

